export default __webpack_public_path__ + "static/media/8Klein.eefb471f.jpg";